import React, { memo, useCallback, useRef, useState } from "react";

// 3rd party Library
import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";
import { TextArea } from "semantic-ui-react";

// Assets & Utils
import { ChatBotImage } from '../../../assets/images/index.js';
import { configurationApi } from '../../services/configurationApi.js';
import { useCommonAlert } from '../../utilities/helpers.js';

//Common components
import CustomModal from '../CustomModal.jsx';

// styles
import styles from "./styles.module.scss";

const ChatBotAI = (props) => {
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const [getChatgptQueryRequest] =
    configurationApi.useGetChatgptQueryRequestMutation();
  const [currentAction, setCurrentAction] = useState("");
  const [responseValueAction, setResponseValueAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [popupshow, setpopupshow] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [typingIntervalId, setTypingIntervalId] = useState(null);
  const [responsestop, setResponsestop] = useState(false);
  const [isErrorResponse, setIsErrorResponse] = useState(false);
  const queryTextareaRef = useRef(null);

  const [state, setState] = useState({
    modalOpen: false,
    modalOpenInfo: false,
    modalOpenManage: false,
    modalAIManage: false,
  });

  const handleShowManage = () => {
    setResponseValueAction("");
    setState({
      ...state,
      modalOpenManage: true,
    });
  };
  const handleShowAI = () => {
    setResponseValueAction("");
    setState({
      ...state,
      modalAIManage: true,
    });
  };

  const handleCloseChat = () => {
    setState({
      ...state,
      modalOpenManage: false,
    });
  };
  const handleCloseAI = () => {
    setpopupshow(false);
    setState({
      ...state,
      modalAIManage: false,
    });
  };
  const handleInputChange = (event) => {
    const queryValue = event.target.value.trim();
    setSubmitDisabled(queryValue === "");
  };

  const resetInput = () => {
    setResponseValueAction("");
    clearInterval(typingIntervalId);
    setResponsestop(false); // Reset responseStopped state to false
    ChatBot();
  };

  const resetQuery = useCallback(() => {
    if (queryTextareaRef.current) {
      queryTextareaRef.current.value = "";
    }
    setSubmitDisabled(true);
  }, []);

  let textareaValue;
  console.log("props", props);

  if (props.passTitle == "Valunerability Management") {
    textareaValue = `How to fix : "${props.passData}"\nPlugin ID : ${props.passPlugin}\nCVE ID: ${props.passCVEID}`;
  } if (props.passTitle == "CIS Benchmark Compliance") {
    textareaValue = `How to fix : "${props.passData}"\nPlugin ID : ${props.passPlugin}`;
  } else if (props.passTitle == "SecurityHubFindings") {
    textareaValue = `How to fix : "${props.passRtitle}."\nType  : ${props.passType}`;
  } else if (props.passTitle == "SBOM") {
    textareaValue = `How to fix : "${props.passData}"\nVulnerability ID : ${props.passPlugin}\nCVE ID: ${props.passCVEID}`;
  } else if (props.passTitle == "Circular9") {
    // Assuming props.passTypes is an array
    const uniqueTypes = props.passTypes.filter(
      (type, index) => props.passTypes.indexOf(type) === index
    );
    textareaValue = `How to fix : "${props.passRule}".\nDescription : ${props.passDes}\nType : ${uniqueTypes}`;
  } else {
    textareaValue = `How to fix : ${props.passData}.\nPlease suggest me some solution to fix this issue `;
  }

  const modelAIMange = () => (
    <div>
      <h4 className="actionDescription mb-3">PII Data Found</h4>
      <TextArea
        className={`${styles["response-text"]} ${isErrorResponse ? styles["response-error"] : ""
          }`}
        rows="7"
        disabled={true}
        value={responseValueAction}
        icon={loading ? "spinner" : null}
        placeholder={loading ? "" : " "}
      />
    </div>
  );

  const modalBodyManage = () => (
    <>
      <div>
        <h4 className="actionDescription mb-3">Ask AI</h4>{" "}
        <img className={styles.ChatbotAlignQuery} src={ChatBotImage} />
        <p className="text-start vulnerabilityFontSize mb-2">
          Please enter your query below
        </p>
        <textarea
          className={styles.ChatBotQuery}
          id="ChatBotQuery"
          ref={queryTextareaRef}
          onChange={handleInputChange}
          rows={7}
          data-testid="chatbot-query-textarea"
        >
          {textareaValue}
        </textarea>
        <div className="server-btn ChatBot">
          <Button
            variant="primary"
            size="sm"
            className="solid-btn"
            onClick={resetQuery}
            data-testid="chatbot-reset-button"
          >
            {" "}
            {currentAction === "edit" ? " ResetQuery" : " Reset Query "}
          </Button>{" "}
          <Button
            variant="primary"
            size="sm"
            className="solid-btn"
            onClick={() => resetInput()}
            disabled={submitDisabled}
            data-testid="chatbot-submit-button"
          >
            {currentAction === "edit" ? " Sumbit" : " Submit "}
          </Button>{" "}
        </div>
        <p className="text-start vulnerabilityFontSize mb-2">Response</p>
        {loading ? (
          <div className={`${styles["loader-chat-mainchat"]}`}>
            <div className={`${styles["loader-chat"]} spl`}></div>
          </div>
        ) : (
          ""
        )}
        <TextArea
          className={`${styles["response-text"]} ${isErrorResponse ? styles["response-error"] : ""
            }`}
          rows="7"
          disabled={true}
          value={!isErrorResponse ? responseValueAction : ""}
          icon={loading ? "spinner" : null}
          placeholder={loading ? "" : " "}
          data-testid="chatbot-response-textarea"
        />
        <div className="server-btn ChatBot">
          <Button
            data-testid="chatbot-regenerate-button"
            variant="primary"
            size="sm"
            className="solid-btn left"
            onClick={() => resetInput()}
            disabled={responseValueAction === "" || submitDisabled || loading}
          >
            {" "}
            {currentAction === "edit" ? " Regenerate" : "Regenerate"}
          </Button>{" "}
        </div>
      </div>
    </>
  );
  const ChatBot = async () => {
    try {
      setLoading(true); // Set loading state to true
      const payload = {
        prompt:
          queryTextareaRef.current.value +
          " give me Maximum 150 words",
      };
      const data = await getChatgptQueryRequest({ payload: payload }).unwrap();
      if (data.body) {
        const description = data.body;
        if (data.statusCodeValue === 400) {
          setpopupshow(true);
          handleShowAI();
          setResponseValueAction(description);
          setIsErrorResponse(true);
        } else {
          setIsErrorResponse(false);
          setResponseValueAction(description);
        }
      }
      setState((prevState) => ({
        ...prevState,
        ChatgptQueryRequestData: data,
      }));
    } catch (error) {
      console.error(error);
      callCommonAlert("error", "Something went wrong. Please try again.");
      hideCommonAlert();
    } finally {
      setLoading(false); // Set loading state to false
      clearInterval(typingIntervalId);
    }
  };

  return (
    <>
      <div className={styles.Chatbotimg}>
        <img
          className=""
          id="align-query"
          onClick={() => {
            if (popupshow) {
              handleShowAI();
            } else {
              handleShowManage();
              setSubmitDisabled(false);
            }
          }}
          src={ChatBotImage}
        ></img>
        <div>
          <Button
            data-testid="chatbot-askAI-button"
            variant="primary"
            size="sm"
            className="left"
            onClick={() => {
              if (popupshow) {
                handleShowAI();
              } else {
                handleShowManage();
                setSubmitDisabled(false);
              }
            }}
          >
            {currentAction === "edit" ? " Ask AI" : " Ask AI "}
          </Button>{" "}
        </div>
      </div>
      <CustomModal
        modalOpen={state.modalOpenManage}
        modalBody={modalBodyManage}
        modalHide={handleCloseChat}
        closeBtn={true}
        closeBtnFuc={handleCloseChat}
        size={"lg"}
      />
      <CustomModal
        modalOpen={state.modalAIManage}
        modalBody={modelAIMange}
        modalHide={handleCloseAI}
        closeBtn={true}
        closeBtnFuc={handleCloseAI}
        size={"md"}
      />
    </>
  );
};

export default memo(ChatBotAI);
ChatBotAI.propTypes = {
  passTitle: PropTypes.string.isRequired,
  passData: PropTypes.string,
  passPlugin: PropTypes.string,
  passCVEID: PropTypes.string,
  passRtitle: PropTypes.string,
  passType: PropTypes.string,
  passRule: PropTypes.string,
  passDes: PropTypes.string,
  passTypes: PropTypes.arrayOf(PropTypes.string),
};



